import React, {Component} from 'react';
import {Modal, Button, Icon, Header ,Segment,SegmentGroup,Form,Message,Search,Loader,Popup,Dimmer} from "semantic-ui-react";
import {getKnowledgeBaseData,createKnowledgeArticle,deleteKnowledgeArticle,updateKnowledgeArticle} from "../../data/dashboard_api";
import moment from 'moment';

class KnowledgeBase extends Component {

    constructor(props){
        super(props);
        this.state = {
            editTitle:undefined,
            editCategory:"",
            editContent:undefined,
            categories:[],
            articles:[  ],
            selected:undefined,
            contentError:undefined,
            loading:true,
            filteredCategory:""
        }
    }
    componentDidMount() {
        this.pullData()
    }
    deleteArticle = async (id) =>{
        this.setState({loading:true})
        await deleteKnowledgeArticle(id)
        this.pullData()
    }
    pullData = async ()=>{
    getKnowledgeBaseData().then((response)=>{

    if(response.success){
        
        let newCategories = []
        let newArticles = response.articles
        newArticles.sort((a, b) => {
            let dateA = new Date(a.created_at), dateB = new Date(b.created_at);
            return dateB - dateA;  }) 
            
            newArticles.map(art =>{
                if (!newCategories.includes(art.category)){
                    newCategories.push(art.category)
                }
                
            })
            
            let catArray = []
            newCategories.map(newcat =>{catArray.push({title:newcat?newcat:""})})
            
        this.setState({categories:[...catArray],articles:[...newArticles],loading:false,editMode:false,selected:undefined,editTitle:undefined,editCategory:"", editContent:undefined,})
    }
    })
}
    
    createArticle = async(edit = false) =>{
        this.setState({loading:true,contentError:undefined})
        if (!this.state.editTitle || !this.state.editCategory || !this.state.editContent){
            this.setState({contentError:true,loading:false})
            return
        }

        let formData = new FormData()
        formData.append("id",this.state.selected)
        formData.append("title", this.state.editTitle);
        formData.append("category", this.state.editCategory);
        formData.append("article", this.state.editContent)
        await createKnowledgeArticle(formData,edit).then(()=>{this.pullData() })
        
    }
    render() {
        return (
            <div>
                <Modal size="large" open={this.props.showKnowledgeBase} onClose={(e) => {
            }}><Modal.Header>Knowledge Base</Modal.Header>
            <Modal.Content style={{paddingTop: '0'}}>
                <div className="modal-close-button">
                    <Button basic icon negative onClick={(e) => {
                        this.props.handleClose();
                    }}><Icon name="close"/></Button>
                </div>
                    <Modal.Description>
                      <div style={{height:"800px",overflowY:"scroll"}}>  
                      {this.props.userRole =="admin" && !this.state.loading && <Segment>
                        <Header as="h3">Add New Article</Header>
                        <Form>
                            <Form.Input required onChange={(e)=>{this.setState({editTitle:e.target.value})}} label="Title"></Form.Input>
                            <Form.Field required> <label>Category</label> 
                        <Search
                            results={this.state.categories.filter(cat =>{return cat.title.toLowerCase().includes(this.state.editCategory.toLowerCase())})}
                            value={this.state.editCategory} 
                            onSearchChange={(e,data) => { this.setState({editCategory:data.value})}} 
                            onResultSelect={(e,data) => { this.setState({editCategory:data.result.title})} }
                            />
                        </Form.Field>
                            <Form.TextArea required onChange={(e)=>{this.setState({editContent:e.target.value})}} label="Content" ></Form.TextArea >
                            <Button disabled={this.state.loading}loading={this.state.loading} onClick={(e)=>{e.preventDefault();
                            this.createArticle()
                            }}>Create Article</Button>
                            {this.state.contentError && <Message>Fields are missing</Message>}
                        </Form>
                        </Segment>}
                        <Segment> <Header>Filter Category</Header><Search
                            results={this.state.categories.filter(cat =>{return cat.title.toLowerCase().includes(this.state.filteredCategory.toLowerCase())})}
                            value={this.state.filteredCategory} 
                            onSearchChange={(e,data) => { this.setState({filteredCategory:data.value})}} 
                            onResultSelect={(e,data) => { this.setState({filteredCategory:data.result.title})} }
                            /></Segment>
                        {this.state.loading && <Segment style={{height:"200px"}} ><Dimmer active inverted><Loader inline='centered' >Loading Articles</Loader></Dimmer></Segment>}
                      {!this.state.loading && this.state.articles.filter(ar=>{return ar.category.toLowerCase().includes(this.state.filteredCategory.toLowerCase())}).map((content, index) =>{
                            return   <div key={index}style={{marginTop:"10px"}}>
                            <SegmentGroup>
                                <Segment className="toggable_heading"><Header><Button compact color="orange" size="mini" basic>{content.category}</Button><Button compact size="mini" basic>{moment(content.created_at).format("DD-MM-YYYY")}</Button>{content.title} {this.props.userRole == "admin" && <React.Fragment>
                                <Popup trigger={<Button basic compact size="mini" color="red" style={{float:"right"}}>Delete</Button>}
                      content={<React.Fragment><Header as="h4">Delete Article?</Header><Button color='green' content='Confirm article deletion' onClick={() => { this.deleteArticle(content.id) }} /></React.Fragment>} on='click' position='top right'/>
                    </React.Fragment>}{this.state.selected == content.id && <Button onClick={()=>{this.setState({selected:content.id,editMode:true,editTitle:content.title,editCategory:content.category,editContent:content.article})}}style={{float:"right"}}compact basic size="mini" color="orange" >Edit</Button>}{this.state.selected !=content.id && <Button style={{float:"right"}} onClick={()=>{this.setState({selected:content.id,editMode:false})}}compact basic size="mini" color="blue" >View</Button> }</Header></Segment>
                             {this.state.selected == content.id &&<Segment>{!this.state.editMode && <div>
                              {content.article.split("\n").map((value, index) => {return (<React.Fragment key={index}>{value}<br /></React.Fragment>);})}
                              </div>}
                              {this.state.editMode && <div> <Form>
                            <Form.Input value={this.state.editTitle} required onChange={(e)=>{this.setState({editTitle:e.target.value})}} label="Title"></Form.Input>
                            <Form.Field required> <label>Category</label> 
                        <Search
                            results={this.state.categories.filter(cat =>{return cat.title.toLowerCase().includes(this.state.editCategory.toLowerCase())})}
                            value={this.state.editCategory} 
                            onSearchChange={(e,data) => { this.setState({editCategory:data.value})}} 
                            onResultSelect={(e,data) => { this.setState({editCategory:data.result.title})} }
                            />
                        </Form.Field>
                            <Form.TextArea autoHeight value={this.state.editContent}required onChange={(e)=>{this.setState({editContent:e.target.value})}} label="Content" ></Form.TextArea >
                            <Button disabled={this.state.loading}loading={this.state.loading} onClick={(e)=>{e.preventDefault();
                            this.createArticle(true)
                            }}>Edit Article</Button>
                            {this.state.contentError && <Message>Fields are missing</Message>}
                        </Form></div>}</Segment>}
                            </SegmentGroup>
                          </div>
                        })}
                        </div>
                        </Modal.Description>
                        </Modal.Content>
                </Modal>
            </div>
        );
    }
}

export default KnowledgeBase;


// WEBPACK FOOTER //
// ./src/views/universal/knowledge_base.js